import styled from 'styled-components';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import { IconButton } from '../icon-button';
import { getThemeProp, getColor, getColorShade, getElevation, getSizeBy } from '../../../src/styled/utils';
import { VIEWPORT_BREAKPOINTS } from '../../../src/styled/global-variables';
export const StyledModal = Modal.styled `
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 95%;

  @media screen and (min-width: ${VIEWPORT_BREAKPOINTS.SMALL}px) {
    min-width: ${getSizeBy(96)};
  }

  max-height: 95%;
  min-height: 200px;
  background-color: ${getColor('surface')};
  border: 1px solid ${getColorShade('onSurface', 'outline')};
  border-radius: ${getThemeProp('borderRadius')}px;
  box-shadow: ${getElevation(16)};
`;
export const ModalHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${getSizeBy(4)} ${getSizeBy(6)};
  border-bottom: 1px solid ${getColorShade('onSurface', 'outline')};
`;
export const ModalContent = styled.div `
  flex-grow: 1;
  padding: ${getSizeBy(6)};
  overflow-y: auto;
`;
export const ModalFooter = styled.footer `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: ${getSizeBy(6)};
  border-top: 1px solid ${getColorShade('onSurface', 'outline')};

  & > * + * {
    margin-left: ${getSizeBy(3)};
  }
`;
export const ModalBackground = styled(BaseModalBackground) `
  background-color: ${getColorShade('shadows', 'mediumEmphasis')};
  backdrop-filter: blur(${getSizeBy(3)});
`;
export const StyledIconButton = styled(IconButton) `
  cursor: pointer;
`;
